export default {"src":"/_next/static/media/loader-alt.81a10adc.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};